import { MemberLevel, MemberStatus } from '../../enums'
import type { WorkspaceMember } from '../../types'

export const WORKSPACE_MEMBERS_MOCK: WorkspaceMember[] = [
  {
    id: 'member-1',
    name: 'John Doe',
    email: 'john.doe@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.ADMIN,
    status: MemberStatus.ACTIVE,
    lastSeen: '2026-03-20T10:30:00.000Z',
    projectIds: ['project-1', 'project-2', 'project-3'],
  },
  {
    id: 'member-2',
    name: 'Alice Martin',
    email: 'alice.martin@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.DEVELOPER,
    status: MemberStatus.ACTIVE,
    lastSeen: '2026-03-20T08:15:00.000Z',
    projectIds: ['project-1', 'project-2'],
  },
  {
    id: 'member-3',
    name: 'Bob Smith',
    email: 'bob.smith@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.DEVELOPER,
    status: MemberStatus.ACTIVE,
    lastSeen: '2026-03-19T14:00:00.000Z',
    projectIds: ['project-1'],
  },
  {
    id: 'member-4',
    name: 'Clara Johnson',
    email: 'clara.johnson@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.ADMIN,
    status: MemberStatus.ACTIVE,
    lastSeen: '2026-03-18T16:45:00.000Z',
    projectIds: ['project-1', 'project-2', 'project-3', 'project-4'],
  },
  {
    id: 'member-5',
    name: null,
    email: 'new.member@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.DEVELOPER,
    status: MemberStatus.PENDING,
    lastSeen: null,
    projectIds: [],
  },
  {
    id: 'member-6',
    name: 'David Lee',
    email: 'david.lee@graftcode.com',
    avatarUrl: null,
    role: MemberLevel.DEVELOPER,
    status: MemberStatus.ACTIVE,
    lastSeen: '2026-03-17T09:30:00.000Z',
    projectIds: ['project-2'],
  },
]
